const VanuatuSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112742)">
      <path
        d="M40 19.9996C40 19.1154 39.9419 18.2448 39.8307 17.3909H17.3911C13.3051 13.3051 5.85753 5.85805 5.85784 5.85742C-1.95261 13.6679 -1.95261 26.3311 5.85784 34.1417L17.3913 22.6083H39.8307C39.9418 21.7543 40 20.8837 40 19.9996Z"
        fill="black"
      />
      <path
        d="M39.994 20.4541C39.9932 20.4927 39.9923 20.5314 39.9912 20.57C39.9921 20.5313 39.9931 20.4927 39.994 20.4541Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9747 21.001C39.9729 21.0392 39.9703 21.0772 39.9683 21.1154C39.9703 21.0773 39.9728 21.0392 39.9747 21.001Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9475 21.4385C39.9435 21.4946 39.9396 21.5508 39.9351 21.6068C39.9396 21.5508 39.9434 21.4946 39.9475 21.4385Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.8809 17.8193C39.8882 17.8862 39.8955 17.953 39.9022 18.02C39.8955 17.9529 39.8881 17.8862 39.8809 17.8193Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9683 18.8828C39.9704 18.9209 39.9729 18.959 39.9747 18.9972C39.9729 18.959 39.9704 18.9209 39.9683 18.8828Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9912 19.4297C39.9923 19.4683 39.9931 19.507 39.994 19.5456C39.9932 19.5069 39.9922 19.4683 39.9912 19.4297Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9351 18.3945C39.9396 18.4505 39.9435 18.5067 39.9475 18.5629C39.9434 18.5067 39.9396 18.4505 39.9351 18.3945Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.8304 17.3912C39.8394 17.4597 39.8474 17.5286 39.8556 17.5973C38.6685 7.68467 30.2321 0 19.9997 0C14.4768 0 9.47671 2.23867 5.85742 5.85811L17.3905 17.3913H39.8304V17.3912Z"
        fill="#D80027"
      />
      <path
        d="M39.8304 22.6084H17.3905L5.85742 34.1416C9.47671 37.761 14.4768 39.9997 19.9997 39.9997C30.2321 39.9997 38.6686 32.3151 39.8556 22.4023C39.8474 22.471 39.8392 22.5399 39.8304 22.6084Z"
        fill="#6DA544"
      />
      <path
        d="M39.9022 21.9795C39.8955 22.0465 39.8882 22.1133 39.8809 22.1802C39.8882 22.1133 39.8956 22.0466 39.9022 21.9795Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9478 18.5615C39.9553 18.6685 39.9622 18.7757 39.9681 18.8831C39.9621 18.7757 39.9553 18.6685 39.9478 18.5615Z"
        fill="black"
      />
      <path
        d="M39.856 17.5977C39.8649 17.6718 39.8735 17.7461 39.8814 17.8205C39.8733 17.7461 39.8648 17.6719 39.856 17.5977Z"
        fill="black"
      />
      <path
        d="M39.9023 18.0205C39.9145 18.1446 39.9255 18.2691 39.9355 18.394C39.9256 18.2691 39.9146 18.1446 39.9023 18.0205Z"
        fill="black"
      />
      <path
        d="M39.9994 20C39.9994 20.1521 39.997 20.3036 39.9937 20.4548C39.997 20.3035 39.9994 20.152 39.9994 20Z"
        fill="black"
      />
      <path
        d="M39.969 21.1152C39.9631 21.2227 39.9562 21.3298 39.9487 21.4368C39.9562 21.3298 39.963 21.2227 39.969 21.1152Z"
        fill="black"
      />
      <path
        d="M39.9355 21.6055C39.9255 21.7302 39.9145 21.8548 39.9023 21.9788C39.9146 21.8548 39.9256 21.7302 39.9355 21.6055Z"
        fill="black"
      />
      <path
        d="M39.8814 22.1807C39.8735 22.255 39.8649 22.3293 39.856 22.4035C39.8648 22.3293 39.8733 22.255 39.8814 22.1807Z"
        fill="black"
      />
      <path
        d="M39.9937 19.5459C39.997 19.6971 39.9994 19.8487 39.9994 20.0007C39.9994 19.8487 39.997 19.6971 39.9937 19.5459Z"
        fill="black"
      />
      <path
        d="M39.9751 18.999C39.9821 19.1421 39.9874 19.2858 39.9915 19.4297C39.9874 19.2857 39.9822 19.1421 39.9751 18.999Z"
        fill="black"
      />
      <path
        d="M39.9915 20.5713C39.9874 20.7152 39.9821 20.8589 39.9751 21.002C39.9823 20.8588 39.9875 20.7152 39.9915 20.5713Z"
        fill="black"
      />
      <path
        d="M39.9809 19.1237H16.6564L4.67537 7.14453C4.2881 7.55297 3.86834 8.12328 3.60873 8.52945L15.0664 19.9932L3.59912 31.4607C3.82615 31.8646 4.32076 32.4625 4.66803 32.8514L16.6566 20.8629H39.9837C39.9962 20.5744 40.0001 20.2847 40.0001 19.9933C40 19.6029 39.9892 19.315 39.9809 19.1237Z"
        fill="#FFDA44"
      />
      <path
        d="M4.8589 24.264V22.5888C6.53062 22.5888 7.89054 21.2287 7.89054 19.5571C7.89054 18.3744 6.92827 17.4122 5.74562 17.4122C4.93992 17.4122 4.28437 18.0677 4.28437 18.8735C4.28437 19.3888 4.70351 19.808 5.21882 19.808C5.51007 19.808 5.74703 19.5709 5.74703 19.2796H7.42218C7.42218 20.4947 6.43374 21.4832 5.2189 21.4832C3.77992 21.4832 2.60938 20.3125 2.60938 18.8737C2.60938 17.1443 4.0164 15.7373 5.7457 15.7373C7.8521 15.7373 9.56585 17.4511 9.56585 19.5574C9.56577 22.1524 7.45429 24.264 4.8589 24.264Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112742">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default VanuatuSvg;
